const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/phoneNumberUtils.ts';
/*
 * Digits appearing in mobile numbers
 */
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export function normalizePhoneNumber(phoneNumber?: string): string {
    const sanitizedPhoneNumber = phoneNumber && phoneNumber.replace(/\n|\s/g, '');

    if (!sanitizedPhoneNumber || !isValidPhoneNumber(sanitizedPhoneNumber, 'CH')) {
        return '';
    }
    const parsedPhoneNumber = parsePhoneNumber(sanitizedPhoneNumber, { defaultCountry: 'CH' });

    return parsedPhoneNumber.formatInternational();
}
